var _g, _path, _path2, _path3, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddtagpayicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 38,
    viewBox: "0 0 48 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_230_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8472 1.01349L14.8374 1.01447L14.8286 1.01544L4.0708 2.09064V2.09161C3.01708 2.2132 2.2131 3.01648 2.09131 4.07013L1.01807 14.7996V14.8006C0.975909 15.4751 1.18558 16.1173 1.66064 16.5926L18.4077 33.3387C19.2456 34.1764 20.6548 34.1765 21.4927 33.3387L33.3394 21.493C34.1771 20.6551 34.1771 19.2449 33.3394 18.407L16.5923 1.66095C16.0931 1.16193 15.4562 0.93746 14.8472 1.01349ZM4.74658 4.74689C5.84717 3.6463 7.66846 3.6463 8.76904 4.74689C9.86923 5.84738 9.86918 7.66784 8.76904 8.76837C7.66846 9.86896 5.84717 9.86896 4.74658 8.76837C3.64625 7.66781 3.6462 5.84742 4.74658 4.74689Z",
    stroke: "#202224",
    strokeOpacity: 0.7,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8692 18.6846L17.123 1.88462C16.4769 1.29231 15.6153 0.969235 14.7538 1.07693L3.98457 2.15385C2.58457 2.31539 1.50764 3.39231 1.3461 4.79231L0.26918 15.4538C0.215336 15.2385 0.215336 15.0231 0.26918 14.8077L1.3461 4.03847C1.50764 2.63847 2.58457 1.56154 3.98457 1.4L14.7538 0.323081C15.6153 0.215389 16.4769 0.538466 17.123 1.18462L33.8692 17.8769C34.5153 18.5231 34.7846 19.4923 34.6769 20.3538C34.623 19.7615 34.3538 19.1692 33.8692 18.6846Z",
    fill: "#202224",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3508 12.5301L12.5604 15.3206C10.8032 17.078 10.8032 19.9272 12.5605 21.6845L16.2266 25.3505C17.984 27.1078 20.8332 27.1077 22.5906 25.3504L25.381 22.5599C27.1383 20.8025 27.1383 17.9533 25.3809 16.1959L21.7148 12.53L21.547 12.3705C19.8374 10.8258 17.2281 10.8259 15.5186 12.3706L15.3508 12.5301Z",
    stroke: "#202224",
    strokeOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8767 18.0153C23.5335 17.6722 22.9347 17.6721 22.5916 18.0153L18.0222 22.5856C17.6582 22.9957 17.6838 23.546 18.0154 23.8776C18.3586 24.2204 18.9575 24.2206 19.3005 23.8776L23.8767 19.3004C24.2199 18.9572 24.2199 18.3585 23.8767 18.0153ZM19.8923 14.0309C19.5491 13.6877 18.9504 13.6877 18.6072 14.0309L14.03 18.6071L14.0222 18.6158L14.0134 18.6237C13.6393 18.9637 13.6393 19.5365 14.0134 19.8766L14.0222 19.8844L14.03 19.8922C14.3732 20.2354 14.972 20.2354 15.3152 19.8922L19.8923 15.316C20.2355 14.9729 20.2354 14.3741 19.8923 14.0309Z",
    stroke: "#202224",
    strokeOpacity: 0.7
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_230_120",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 18,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 28C29 23.03 33.03 19 38 19C42.97 19 47 23.03 47 28C47 32.97 42.97 37 38 37C33.03 37 29 32.97 29 28Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 28H43",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "12 12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 23V33",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "12 12"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_230_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 16H50V40H26V16Z",
    fill: "#1C9056"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_230_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "matrix(-1 0 0 1 35 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddtagpayicon);
export default __webpack_public_path__ + "static/media/addtagpayicon.fb2f57acf517a4414b2844726492b891.svg";
export { ForwardRef as ReactComponent };